@if (modeView !== ModeView.CREATE) {
	<div>
		<h5>
			<div class="d-flex align-items-center"
				 role="button" tabindex="0" (click)="toggle()" style="cursor: pointer; user-select: none;">
				<span
					[ngClass]="showMetadata ? 'fa fa-caret-up fa-rotate-180' : 'fa fa-caret-up fa-rotate-90'"
					style="margin-right: 5px; color: rgb(51, 122, 183);">
				</span>
				<span class="control-label fw-bold" jhiTranslate="ontology-manager.metadata.title">
				</span>
			</div>
		</h5>
	</div>
	@if (showMetadata) {
		<br>
		@if (metadata.usage.variables !== undefined) {
			<div class="mb-3 row">
				<label class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.metadata.used.in.variables">
				</label>
				<div class="col-sm-9">
					<p class="form-control-plaintext mb-0">
						{{ formatListForDisplay(metadata.usage.variables) }}
					</p>
				</div>
			</div>
		}
		@if (extendedUsage) {
			<div class="mb-3 row" *ngFor="let item of usageFields">
				<label class="col-sm-3 col-form-label fw-bold" [jhiTranslate]="item.label">
				</label>
				<div class="col-sm-9">
					<p class="form-control-plaintext mb-0">
						{{ metadata?.usage?.[item.field] ?? 0 }}
					</p>
				</div>
			</div>
			<div class="mb-3 row">
				<label class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.metadata.system.variable">
				</label>
				<div class="col-sm-9">
					<p class="form-control-plaintext mb-0">
						{{ metadata?.usage?.systemTerm ? 'Yes' : 'No' }}
					</p>
				</div>
			</div>
		}
		<div class="mb-3 row">
			<label class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.metadata.date.created">
			</label>
			<div class="col-sm-9">
				<p class="form-control-plaintext mb-0">
					{{ metadata?.dateCreated ? (metadata?.dateCreated | date) : '-' }}
				</p>
			</div>
		</div>
		<div class="mb-3 row">
			<label class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.metadata.date.last.modified">
			</label>
			<div class="col-sm-9">
				<p class="form-control-plaintext mb-0">
					{{ metadata?.lastModified ? (metadata?.lastModified | date) : '-' }}
				</p>
			</div>
		</div>
	}
}
